<ion-button
  fill="clear"
  [color]="color"
  [size]="size === 'sm' ? 'small' : 'default'"
  [disabled]="disabled || loading"
  [attr.aria-label]="ariaLabel"
  [attr.title]="showTooltip ? ariaLabel : null"
  [attr.aria-busy]="loading"
  (click)="onClick($event)">
  <ion-spinner *ngIf="loading" slot="icon-only" name="crescent" aria-hidden="true"></ion-spinner>
  <ion-icon *ngIf="!loading" slot="icon-only" [name]="iconSrc ? null : icon" [src]="iconSrc || null" aria-hidden="true"></ion-icon>
</ion-button>